const initialState = () => {
    return {
        /**
         * @description
         * Here you should declare the state properties and it's initial values
         */
        arrayDiscounts: [],
        id: null,
        maxPriceDiscount: null,

        prevArrayDiscounts: [],
        arrayDiscountsUploads: 0,

        globalPercentageDiscount: false,
    }
}

export default initialState
